exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#best_for_kids input {\n\tmargin-right: 2em;\n}\n#best_for_kids label {\n\tfont-weight: normal;\n}\n\n", ""]);

// exports
